import { MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_LABELS,
  BUTTON_VARIANTS,
  MODAL_TITLES,
} from "@miplatform/constants";
import { ICategoryDropsResponse } from "@miplatform/types";
import { mdiTrashCanOutline } from "@mdi/js";
import { useTheme } from "@mui/material";

export function DeleteCategoryDropModal({
  open,
  selectedDrop,
  handleDeleteCategoryDrop,
  categoryId,
  closeModal,
}: DeleteCategoryDropModalProps) {
  const theme = useTheme();

  return (
    <MiModal
      open={open}
      closeModal={closeModal}
      title={MODAL_TITLES.DELETE}
      titleIcon={mdiTrashCanOutline}
      leftIconColor={theme.palette.error.main}
      description={
        <>
          Are you sure you want to delete{" "}
          <span
            style={{
              fontWeight: theme.fontWeight.semiBold,
              color: theme.palette.primary.main,
            }}
          >
            {selectedDrop?.name}
          </span>{" "}
          drop type? This will remove this drop type from all price levels and
          assigned customers. This action cannot be undone.
        </>
      }
      actions={[
        {
          name: BUTTON_LABELS.CANCEL,
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: closeModal,
        },
        {
          name: BUTTON_LABELS.DELETE,
          variant: BUTTON_VARIANTS.CONTAINED,
          color: BUTTON_COLORS.ERROR,
          onClick: () => {
            if (selectedDrop) {
              handleDeleteCategoryDrop(categoryId, selectedDrop);
            }
            closeModal();
          },
        },
      ]}
    />
  );
}

interface DeleteCategoryDropModalProps {
  open: boolean;
  selectedDrop: ICategoryDropsResponse | null;
  handleDeleteCategoryDrop: (
    categoryId: string,
    data: Partial<ICategoryDropsResponse>
  ) => void;
  categoryId: string;
  closeModal: () => void;
}
